import { __assign } from "tslib";
import React from 'react';
import { TextField } from '@material-ui/core';
import { isNil } from '../../utils';
var Variantes;
(function (Variantes) {
    // eslint-disable-next-line no-unused-vars
    Variantes["DEFAULT"] = "standard";
    // eslint-disable-next-line no-unused-vars
    Variantes["FILLED"] = "filled";
    // eslint-disable-next-line no-unused-vars
    Variantes["OUTLINED"] = "outlined";
})(Variantes || (Variantes = {}));
var Sizes;
(function (Sizes) {
    // eslint-disable-next-line no-unused-vars
    Sizes["SMALL"] = "small";
    // eslint-disable-next-line no-unused-vars
    Sizes["NORMAL"] = "medium";
})(Sizes || (Sizes = {}));
/**
 * MyInput.
 *
 * @param {InputProps} props input's props
 * @returns {React.FC<InputProps>} TextField.
 */
export var MyInput = function (options) {
    if (options.select && !options.children)
        throw "Can't define a select without items to choice";
    var numberPattern = '\\d*';
    var copyOptions = Object.assign({}, options);
    if (copyOptions.type === 'number') {
        copyOptions.type = 'text';
        if (copyOptions.subInputProps)
            copyOptions.subInputProps = __assign({ pattern: numberPattern }, copyOptions.subInputProps);
        else
            copyOptions.subInputProps = { pattern: numberPattern };
    }
    else if (isNil(copyOptions.type))
        copyOptions.type = 'text';
    var onChangeCallback = function (event) {
        var _a, _b, _c, _d;
        var hasValue = !isNil(((_a = event.currentTarget) === null || _a === void 0 ? void 0 : _a.value) || ((_b = event.target) === null || _b === void 0 ? void 0 : _b.value));
        if (hasValue && !copyOptions.disabled && copyOptions.onChange)
            copyOptions.onChange(((_c = event.currentTarget) === null || _c === void 0 ? void 0 : _c.value) || ((_d = event.target) === null || _d === void 0 ? void 0 : _d.value));
    };
    var customIsNaN = function (expectedValue) {
        if (typeof expectedValue === 'number')
            return true;
        else if (typeof expectedValue === 'string' && !Number.isNaN(Number(expectedValue)) && expectedValue !== ' ') {
            return true;
        }
        else
            return false;
    };
    var onChangeValidator = function (event) {
        var _a, _b, _c;
        if ((_a = copyOptions.subInputProps) === null || _a === void 0 ? void 0 : _a.pattern) {
            var pattern = copyOptions.subInputProps.pattern;
            var re = new RegExp("" + pattern);
            var value = ((_b = event.currentTarget) === null || _b === void 0 ? void 0 : _b.value) || ((_c = event.target) === null || _c === void 0 ? void 0 : _c.value);
            if (!value)
                onChangeCallback(event);
            else if (pattern !== numberPattern && !re.test(value))
                return;
            else if (pattern === numberPattern && !customIsNaN(value) && re.test(value))
                return;
        }
        onChangeCallback(event);
    };
    return (React.createElement(TextField, __assign({}, copyOptions.props, { onChange: onChangeValidator, onKeyPress: function (event) {
            if (!copyOptions.disabled && copyOptions.onKeyPress)
                copyOptions.onKeyPress(event);
        }, label: copyOptions.label, disabled: copyOptions.disabled, required: copyOptions.required, autoComplete: copyOptions.autoComplete ? 'on' : 'off', error: copyOptions.error, multiline: copyOptions.multiline, select: copyOptions.select, multiple: copyOptions.multiple, value: copyOptions.defaultValue, fullWidth: !copyOptions.fullWidth, rows: copyOptions.multiline ? 4 : null, variant: copyOptions.variant ? copyOptions.variant : Variantes.DEFAULT, type: copyOptions.type, maxDate: copyOptions.maxDate && new Date(copyOptions.maxDate), defaultValue: copyOptions.defaultValue, helperText: copyOptions.helperText, inputProps: copyOptions.subInputProps, size: copyOptions.size ? copyOptions.size : Sizes.NORMAL, "data-testid": copyOptions.testId, className: copyOptions.className, onPaste: function (event) {
            if (copyOptions.disablePaste)
                event.preventDefault();
        } }), copyOptions.select && copyOptions.children ? copyOptions.children : null));
};
//# sourceMappingURL=Input.js.map